<template>
  <v-container id="user-profile-view" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="4">
        <app-card class="mt-4 text-center">
          <v-img
            class="rounded-circle elevation-6 mt-n12 d-inline-block"
            src="/profile2.png"
            width="128"
          />

          <v-row v-if="userData != null">
            <v-card-text class="text-center">
              <h6 class="text-h6 mb-2 text--secondary">
                {{ userData.occupation }}
              </h6>
              <h4 class="text-h4 mb-3 text--primary">
                {{ userData.firstName }}, {{ userData.lastName }}
              </h4>

              <p class="text--primary">
                {{ userData.phone }}, {{ userData.email }}
              </p>
              <p class="text--primary">
                {{ userData.bio }}
              </p>
              <v-img class="text-center" src="/qrcode.png" width="20%" />
              <!-- <v-btn class="mr-0" color="primary" min-width="100" rounded>
                Follow
              </v-btn> -->
            </v-card-text>
          </v-row>
        </app-card>
      </v-col>
      <v-col cols="12" md="6">
        <my-setting ></my-setting>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MySetting from "@/views/MySetting";
import { mapState } from "vuex";
import { currentUser } from "../firebaseConfig";
const fb = require("../firebaseConfig.js");
export default {
  name: "UserProfileView",
  data: () => ({
    userData: null,
  }),
  components: {
    MySetting,
  },
  computed: {
    ...mapState(["currentUser", "userProfile"]),
  },
  created() {
    fb.db
      .collection("/schools/YJHjHWUGDok8teDhDIKX/employees/")
      .where("email", "==", this.currentUser.email)
      .limit(1)
      .get()
      .then((datas) => {
        if (!datas.empty) {
          var userDoc = datas.docs[0];
          if (userDoc != null && userDoc.exists) {
            this.userData = userDoc.data();
            this.userData.id = userDoc.id;
            this.userData.ref = userDoc.ref;
            //this.$store.dispatch("setEnabledTrue");
            this.$store.commit("setUserProfile", this.userData);
          }
        } else {
          // this.accessOK = false
        }
      });
      
  },
};
</script>
